<template>
  <div class="login-container">
    <header class="register-header">
      <router-link to="/">
        <div class="register-logo">
          <!--          <img-->
          <!--            src="../../assets/logo_zerek.svg"-->
          <!--            alt="Zerek Logo"-->
          <!--            class="register-logo-img"-->
          <!--          />-->
          <span v-html="logoZerek" />
          <div class="register-logo-text">
            <h1>ZEREK</h1>
            <TextField tag="span" weight="700"
              >{{ $t(`landing.zerekTitlePart1`) }}
              <p class="zerek-title-block">
                {{ $t("landing.zerekTitlePart2") }}
              </p>
            </TextField>
          </div>
        </div>
      </router-link>
      <LanguageDropdown :languages="languages" />
    </header>

    <div class="register-step-wrapper">
      <v-stepper v-model="step">
        <v-stepper-header>
          <template v-for="item in 3">
            <v-stepper-step
              :key="item"
              :step="item"
              :complete="step > item"
              class="custom-step"
              :class="{ clickable: item < step }"
              @click="handleStepClick(item)"
            >
              {{
                step <= item ? `${item}-${$t(`registration.step`)}` : "\u00A0"
              }}
            </v-stepper-step>

            <v-divider
              :key="item + 'bind'"
              v-if="item <= 2"
              :class="{ 'active-divider': step > item }"
            ></v-divider>
          </template>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <Step1 @nextStep="step = 2" />
          </v-stepper-content>

          <v-stepper-content step="2">
            <Step2 @nextStep="step = 3" />
          </v-stepper-content>

          <v-stepper-content step="3">
            <Step3 />
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>
  </div>
</template>

<script>
import Step1 from "@/views/login/Step1.vue";
import Step2 from "@/views/login/Step2.vue";
import Step3 from "@/views/login/Step3.vue";
import LanguageDropdown from "@/components/custom/LanguageDropdown.vue";
import logoZerek from "!!raw-loader!@/assets/logo_zerek.svg";

export default {
  components: { LanguageDropdown, Step1, Step2, Step3 },
  data() {
    return {
      logoZerek,
      step: 1,
      languages: [
        { code: "kk", name: "Қазақша" },
        { code: "ru", name: "Русский" },
        // { code: "en", name: "English" },
      ],
    };
  },
  methods: {
    handleStepClick(targetStep) {
      if (targetStep < this.step) {
        this.step = targetStep;
      }
    },

    validateStep(step) {
      let currentStepComponent = this.$refs[`step${step}`];
      if (currentStepComponent && currentStepComponent.validateForm) {
        return currentStepComponent.validateForm();
      }
      return true;
    },

    goToNextStep() {
      if (this.validateStep(this.step)) {
        this.step++;
      }
    },
  },
};
</script>

<style scoped>
/deep/ .v-stepper__label {
  display: block !important;
}
::v-deep.register-logo span svg {
  width: 40px;
  height: 40px;
}
.custom-step.clickable {
  cursor: pointer;
}
.custom-step.clickable:hover {
  opacity: 0.8;
  transition: 0.2s ease;
}
.login-container {
  width: 100%;
  height: 100vh;
  background-color: #f5f8ff;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.register-header {
  width: 90%;
  max-width: 1200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
}
.register-logo {
  display: flex;
  align-items: center;
  gap: 10px;
}
.zerek-title-block {
  margin-bottom: 0 !important;
}
.register-logo-img {
  width: 40px;
  height: 40px;
}
.register-logo-text h1 {
  margin: 0;
  font-size: 18px;
  font-weight: bold;
  color: #000;
}
.logo-text span {
  font-size: 16px;
  color: #666;
  font-family: "Inter", sans-serif;
}
.registration-container {
  width: 100%;
  height: 100vh;
  background-color: #f5f8ff;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.register-step-wrapper {
  //max-width: 500px;
  width: 100%;
}
::v-deep .v-stepper__step__step {
  display: none !important;
}
::v-deep .v-stepper__step {
  flex-direction: column;
  padding: 24px 24px 13px;
}
.custom-step {
  font-weight: 900;
}
::v-deep .v-stepper__step:nth-child(1)::before {
  content: "\F0009";
  font-family: "Material Design Icons";
  font-size: 50px;
  color: gray;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

::v-deep .v-stepper__step:nth-child(3)::before {
  content: "\F01F0";
  font-family: "Material Design Icons";
  font-size: 33px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #6a6a6a;
  width: 50px;
  margin-top: 8px;
}
::v-deep .v-stepper__step:nth-child(3) .v-stepper__label {
  margin-top: 13px;
  display: block !important;
}

::v-deep .v-stepper__step:nth-child(5)::before {
  content: "\F0009";
  font-family: "Material Design Icons";
  font-size: 50px;
  color: gray;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}
::v-deep .v-stepper,
.v-sheet.v-stepper {
  box-shadow: none;
  max-width: 500px;
  margin: 0 auto;
}
::v-deep .v-stepper__header {
  height: 130px;
  display: flex;
  align-items: center;
  box-shadow: none;
  background-color: #f5f8ff;
}
/* Активный шаг */
::v-deep .v-stepper__step--editable:nth-child(1)::before {
  color: #5e5af9;
}

::v-deep .v-stepper__items {
  background-color: #f5f8ff;
}
::v-deep .v-stepper__content {
  background-color: #f5f8ff;
}
::v-deep .v-stepper__wrapper {
  background-color: #f5f8ff;
  border-radius: 30px;
  box-shadow: 0px 0px 8px -3px rgba(0, 0, 0, 0.75);
}
/* Завершенный шаг */
::v-deep .v-stepper__step--complete:nth-child(1)::before {
  color: #3bde00;
}
::v-deep .step-card.v-card {
  padding: 30px;
}
::v-deep .v-stepper__step--complete:nth-child(3)::before {
  color: #ffffff;
  background: #3bde00 !important;
}
::v-deep .v-stepper__step--active:nth-child(3)::before {
  color: #ffffff;
  background: #5e5af9 !important;
}
::v-deep .v-stepper__step--inactive:nth-child(3)::before {
  color: #ffffff;
  background: #6a6a6a !important;
}

.theme--light.v-stepper .v-stepper__step--editable:hover {
  border-radius: 24%;
}

::v-deep .active-divider {
  background-color: #3bde00 !important;
}
.custom-step .completed-step {
  margin-bottom: 13px;
}
.v-divider {
  background-color: #cbcdd2;
  min-height: 3px !important;
  border-radius: 32px;
}
</style>
